import uuid from 'react-uuid';

import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IReceipt } from '../types/ViewReceipt';
import axios from '../utils/axios';

import type { RootState } from '../app/store';
type CompanyInputParams = {
  companyId: string;
  body: any;
};

export const fetchCompanyPOs = createAsyncThunk(
  'viewReceipt/fetchCompanyPOs',
  async ({ companyId, body }: CompanyInputParams) => {
    const response = await axios.post(`/POReceipt/Filter?companyId=${companyId}`, body);
    return response.data;
  }
);
export const fetchAllCompanyPOs = createAsyncThunk(
  'viewReceipt/fetchAllCompanyPOs',
  async ({ companyId, body }: CompanyInputParams) => {
    const response = await axios.post(`/POReceipt/Filter?companyId=${companyId}`, body);
    return response.data;
  }
);

export const Delete = createAsyncThunk('viewReceipt/Delete', async (receiptIdArray: number[]) => {
  const response = await axios.post(`/Receipt/Delete`, receiptIdArray);
  return response.data;
});

export const Undelete = createAsyncThunk(
  'viewReceipt/Undelete',
  async (receiptIdArray: number[]) => {
    const response = await axios.post(`/Receipt/Undelete`, receiptIdArray);
    return response.data;
  }
);

export const Complete = createAsyncThunk(
  'viewReceipt/Complete',
  async (receiptIdArray: number[]) => {
    const response = await axios.post(`/Receipt/Complete`, receiptIdArray);
    return response.data;
  }
);

export const Reopen = createAsyncThunk('viewReceipt/Reopen', async (receiptIdArray: number[]) => {
  const response = await axios.post(`/Receipt/ReOpen`, receiptIdArray);
  return response.data;
});

export interface ViewReceiptsDataProps {
  receiptData: {
    data: IReceipt[];
    total: number;
  };
  getCallStatus: 'pending' | 'succeeded' | 'failed';
  deleteCallStatus: 'pending' | 'succeeded' | 'failed';
  undeleteCallStatus: 'pending' | 'succeeded' | 'failed';
  cancelCallStatus: 'pending' | 'succeeded' | 'failed';
  completeCallStatus: 'pending' | 'succeeded' | 'failed';
  reopenCallStatus: 'pending' | 'succeeded' | 'failed';
}

const initialState = {
  receiptData: { data: [], total: 0 },
  getCallStatus: 'pending',
  deleteCallStatus: 'pending',
  undeleteCallStatus: 'pending',
  cancelCallStatus: 'pending',
  completeCallStatus: 'pending',
  reopenCallStatus: 'pending',
} as ViewReceiptsDataProps;

export const viewReceiptsSlice = createSlice({
  name: 'viewReceipt',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyPOs.fulfilled, (state, action: PayloadAction<any>) => {
        state.receiptData = { data: action.payload.items, total: action.payload.totalRecords };
        state.getCallStatus = 'succeeded';
      })
      .addCase(fetchCompanyPOs.rejected, (state) => {
        state.getCallStatus = 'failed';
      })
      .addCase(fetchCompanyPOs.pending, (state) => {
        state.getCallStatus = 'pending';
      })
      .addCase(Delete.fulfilled, (state, action: PayloadAction<any>) => {
        state.deleteCallStatus = 'succeeded';
      })
      .addCase(Delete.rejected, (state) => {
        state.deleteCallStatus = 'failed';
      })
      .addCase(Delete.pending, (state) => {
        state.deleteCallStatus = 'pending';
      })
      .addCase(Undelete.fulfilled, (state, action: PayloadAction<any>) => {
        state.undeleteCallStatus = 'succeeded';
      })
      .addCase(Undelete.rejected, (state) => {
        state.undeleteCallStatus = 'failed';
      })
      .addCase(Undelete.pending, (state) => {
        state.undeleteCallStatus = 'pending';
      })
      .addCase(Reopen.fulfilled, (state, action: PayloadAction<any>) => {
        state.reopenCallStatus = 'succeeded';
      })
      .addCase(Reopen.rejected, (state) => {
        state.reopenCallStatus = 'failed';
      })
      .addCase(Reopen.pending, (state) => {
        state.reopenCallStatus = 'pending';
      });
  },
});

// export const selectReceiptUse = (state: RootState) => state.viewReceipts
export default viewReceiptsSlice.reducer;

export const selectReceiptUse = (state: RootState) => {
  const receipts = state.viewReceipts;
  return {
    ...receipts,
    receiptData: {
      data: receipts.receiptData.data.map((receipt: IReceipt) => ({ ...receipt, rowId: uuid() })),
      total: receipts.receiptData.total,
    },
  };
};
